import React from 'react';

export const Header = () => {
  return (
    
    <header>
     <h1 className='header__title-app animate__animated  animate__fadeIn'>Where in the world</h1> 
    </header>

  )
}